export class StringUtils {
  static limparMascara(valor: string | null | undefined): string {
    if (!valor) return '';
    return valor.replace(/\D/g, '');
  }

  static removerEspacos(valor: string | null | undefined): string {
    if (!valor) return '';
    return valor.trim();
  }

  static removerEspacosDuplicados(valor: string | null | undefined): string {
    if (!valor) return '';
    return valor.replace(/\s+/g, ' ').trim();
  }

  static capitalizarPrimeira(valor: string | null | undefined): string {
    if (!valor) return '';
    return valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
  }

  static capitalizarPalavras(valor: string | null | undefined): string {
    if (!valor) return '';
    return valor
      .split(' ')
      .map(word => this.capitalizarPrimeira(word))
      .join(' ');
  }

  static truncar(
    valor: string | null | undefined,
    comprimentoMaximo: number,
    sufixo = '...',
  ): string {
    if (!valor) return '';
    if (valor.length <= comprimentoMaximo) return valor;
    return valor.substring(0, comprimentoMaximo) + sufixo;
  }

  static eNuloOuVazio(valor: string | null | undefined): boolean {
    return !valor || valor.trim().length === 0;
  }

  static naoENuloOuVazio(valor: string | null | undefined): boolean {
    return !this.eNuloOuVazio(valor);
  }

  static formatarNomeCampo(nomeCampo: string | null | undefined): string {
    if (!nomeCampo) return '';

    return nomeCampo
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();
  }

  static sanitizarTextoComAcentuacao(valor: string | null | undefined): string {
    if (!valor) return '';
    return valor.replace(/[^\p{L}\p{N}\s]/gu, '').trim();
  }
}
